import React, { Component } from 'react';
import { connect } from 'react-redux';
import FontAwesome from 'react-fontawesome';
import { sprintf } from 'sprintf-js';
import actions from '../../redux/actions';
import Heading from '../Heading';

class Complete extends Component {
  handleClick = (e) => {
    this.props.resetAttribute();
    this.props.router.push('/');
  };

  componentDidMount() {
    window.onpopstate = this.onBackButtonEvent;
  }

  componentWillUnmount() {
    this.props.resetAttribute();
  }

  onBackButtonEvent = (e) => {
    e.preventDefault();
    this.props.resetAttribute();
    this.props.router.push('/copyright-reg');
  };

  render() {
    const { coreg } = this.props;
    const confirmNumber = coreg ? sprintf('%06d', coreg.id) : '';

    return (
      <div className="complete">
        <Heading text="Thanks for registering!" />
        <div className="content">
          <p>
            <FontAwesome name="check-circle" className="icon" />
          </p>
          <p>
            <b className="text-green">
              You have successfully submitted your application.
            </b>
          </p>
          <p>
            Please note that it may take over 7+ months for the U.S. Copyright
            Office to process your application once Cosynd has filed it on your
            behalf. The Copyright Office may deny your application if the
            information you have entered is false or does not meet their
            standards for registration. If there are any issues with your
            application, we'll work with you to resolve them. Otherwise, you can
            expect to receive your certificate in the mail.
          </p>
          <div className="tracking-number">
            <h4 className="text-primary">Tracking Number: {confirmNumber}</h4>
            <p>
              You can reference this tracking number if you need to communicate
              with us about your registration.
            </p>
          </div>
          <div>
            <button onClick={this.handleClick}>Done</button>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  coreg: state.coreg.coreg,
});

const mapDispatchToProps = (dispatch) => ({
  resetAttribute: () => {
    dispatch(actions.resetCoregAttribute());
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Complete);



// WEBPACK FOOTER //
// src/components/Copyright/Complete.jsx